/*
Hinge Plates

  --thickness <float::enum> | millimeters | [0, 3, 6, 9, 18]
  --wedges <bool> | checkbox
*/
import hardwareFormFields from '@/modules/standardItems/schemas/hardware/form'

export default [
  ...hardwareFormFields,
  {
    key: 'thickness',
    value: 'thickness',
    type: 'select',
    // required: true,
    classes: ['xs12', 'sm4', 'input--short'],
    attributes: {
      label: 'Thickness',
      // required: true,
      class: ['input--dense'],
      suffix: 'mm'
    },
    values: ['0mm', '3mm', '6mm', '9mm', '18mm']
  },
  {
    key: 'wedges',
    value: 'wedges',
    type: 'checkbox',
    default: false,
    class: ['xs12', 'sm4', 'input__wrapper', 'input__wrapper--centered'],
    attributes: {
      label: 'Wedges',
      class: ['input--dense']
    }
  }
]
